import * as yup from 'yup'
import { DashboardWidgetsVisibilityFormProfile } from './dashboard-preferences-form.profile'
export const dashboardPreferencesFormId = 'dashboard-preferences-form'
export const schema: yup.ObjectSchema<DashboardWidgetsVisibilityFormProfile> = yup.object({
  isYardCapacityWidgetVisible: yup.boolean().required(),
  isContainerAttributesWidgetVisible: yup.boolean().required(),
  isVesselVisitsWidgetVisible: yup.boolean().required(),
})
